<div class="wrapper-card">
	<div class="wrapper-card__header">
		<ng-content select="[wrapper-card-header]"></ng-content>
	</div>
	<div class="wrapper-card__body">
		<ng-content select="[wrapper-card-body]"></ng-content>
	</div>
</div>